export default __webpack_public_path__ + "static/media/checkbox_element.2f91f006.svg";